<template>
    <div class="login" style="padding-top: 0">
        <b-container>
            <b-row class="justify-content-center items-center">

                <b-col cols="12" md="4" class="bg-white p-0">
                    <img src="../assets/images/login.png" alt="login" class="mw-100 h-100">
                </b-col>

                <b-col cols="12" md="4" class="bg-white p-3">
                    <div class="p-8 login-tabs-container">

                        <div class="mb-3">
                            <h4 class="mb-1">Login</h4>
                            <p>Welcome back, please login to your account.</p>
                        </div>

                        <div>
                            <b-form-input
                                type="text"
                                name="login"
                                placeholder="Login"
                                v-model="loginForm.login"
                                class=" mb-3"></b-form-input>
                            <span class="text-danger text-sm" style="display: none"></span>
                            <b-form-input
                                type="password"
                                name="password"
                                placeholder="Password"
                                v-model="loginForm.password"
                                class="mb-3" @keyup.enter="signIn"></b-form-input>
                            <span style="display: none"></span>
                            <div class=" text-center mb-2">
                                <b-button variant="success" @click="signIn">Login</b-button>
                            </div>
                        </div>

                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import $ from 'jQuery';
    import { mapMutations } from 'vuex';
    import router from "vue-bootstrap-typeahead/src/router";

    export default {
        data() {
            return {
                loginForm: {
                    login: "",
                    password: "",
                    type:'1'
                },
                api:"https://gamejava.monkeytree.com.hk/vue/vueLogin?",
            }
        },
        created() {
            this.getUser();
        },
        methods: {
            ...mapMutations(['changeLogin']),
            getUser() {
                var that = this;
                that.$axios.get("https://gamejava.monkeytree.com.hk/vue/getUser?" + "token=" + localStorage.getItem("token"),{
                    withCredentials: true
                }).then(function (resp){
                    // console.log(resp.data.success)
                    if(resp.data.success === "true"){
                        localStorage.setItem('token', resp.data.token);
                        that.$router.push({path: '/home'});
                    }
                })
            },
            signIn() {
                let userForm = this.loginForm;
                let loader = this.$loading.show({});
                if (userForm.login === '' || userForm.password === '') {
                    alert('Account and password cannot be empty');
                    loader.hide();
                    return;
                }
                const requestLogin = (type) => this.$axios({
                    method: 'post',
                    url: this.api + "login=" + userForm.login + "&" +
                        "password=" + userForm.password + "&" +
                        "type=" + type
                });
                const finishLogin = (res) => {
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('isToken', res.data.success);
                    this.$router.push({path: '/home'});
                };
                requestLogin(userForm.type).then(res => {
                    if (res.data.success === "true") {
                        finishLogin(res);
                        loader.hide();
                        return;
                    }
                    // 部分账号只在 type=2 下有效，type=1 失败后再试一次
                    return requestLogin('2').then(res2 => {
                        if (res2.data.success === "true") {
                            finishLogin(res2);
                        } else {
                            alert('user name or password is error !');
                        }
                        loader.hide();
                    });
                }).catch(error => {
                    console.log(error);
                    loader.hide();
                });
            },
        },
        // mounted() {
        //     AppOptions.appWithoutSidebar = true;
        //     AppOptions.appWithoutHeader = true;
        //     AppOptions.appContentFullWidth = true;
        // },
        // beforeRouteLeave(to, from, next) {
        //     AppOptions.appWithoutSidebar = false;
        //     AppOptions.appWithoutHeader = false;
        //     AppOptions.appContentFullWidth = false;
        //     next();
        // },
    }
</script>
